module.exports = __webpack_public_path__ + "static/media/qbdii.a1f11862.svg";